<h2>Datepicker</h2>

<vitamui-select
  placeholder="Choix du format de date"
  [(ngModel)]="selectedFormat"
  [options]="availableFormats"
  [enableSearch]="false"
  (ngModelChange)="generateConfig()"
></vitamui-select>

@for (config of configs; track config) {
  <h3>{{ config.outputType }}</h3>
  <p>{{ config.description }}</p>
  @for (item of config.items; track item.pickerType) {
    <h4>{{ item.pickerType | titlecase }}</h4>
    <div class="gap-2 align-items-stretch">
      <div class="row">
        <div class="col-1"></div>
        <div class="col row">
          @for (column of columns; track column) {
            <h5 class="col-3">{{ column | titlecase }}</h5>
          }
        </div>
      </div>
      @for (entry of Object.entries(item.rows); track entry[0]) {
        <div class="row">
          <h5 class="col-1">{{ entry[0] | titlecase }}</h5>
          <div class="col row">
            @for (column of columns; track column) {
              <vitamui-datepicker
                class="col-3"
                [class.focused]="column === 'active'"
                [formControl]="entry[1][column]"
                [pickerType]="item.pickerType"
                [outputType]="config.outputType"
                label="Date"
                [format]="formats[selectedFormat].get(item.pickerType)"
              ></vitamui-datepicker>
            }
          </div>
        </div>
      }
    </div>
  }
  <hr />
}

<h3>Min/Max</h3>
<p>Each datepicker date choice is limited by the other.</p>
<div class="row">
  <vitamui-datepicker
    class="col-3"
    [formControl]="startDate"
    pickerType="day"
    label="Start date"
    [max]="endDate.value"
    [format]="formats[selectedFormat].get('day')"
  ></vitamui-datepicker>
  <vitamui-datepicker
    class="col-3"
    [formControl]="endDate"
    pickerType="day"
    label="End date"
    [min]="startDate.value"
    [format]="formats[selectedFormat].get('day')"
  ></vitamui-datepicker>
</div>
